import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import React, { useState } from 'react';
import { TextField } from "@mui/material";
import settings from "./appSettings";

const Login: React.FC = () => {
  const { instance } = useMsal();
  const [email, setEmail] = useState('');

  const shouldUseCommonAuthority = (normalizedEmail: string): boolean => {
    if (settings.loginAuthorityMode === "common") {
      return true;
    }
    if (settings.loginAuthorityMode !== "auto") {
      return false;
    }

    return settings.commonLoginDomains.some((domain) => {
      const normalizedDomain = domain.trim().toLowerCase();
      return (
        normalizedEmail.endsWith(`@${normalizedDomain}`) ||
        normalizedEmail.endsWith(normalizedDomain)
      );
    });
  };

  const redirectAsync = async () => {
    const normalizedEmail = email.trim().toLowerCase();
    const authority = shouldUseCommonAuthority(normalizedEmail)
      ? "https://login.microsoftonline.com/common"
      : `https://login.microsoftonline.com/${settings.tenantId}`;

    instance
      .loginRedirect({
        ...loginRequest,
        loginHint: normalizedEmail,
        authority,
      })
      .catch((error) => console.log(error));
  };

  const handleRedirect = () => {
    redirectAsync();
  };

  const getLanguage = () => window.localStorage.i18nextLng || navigator.language || 'en';

  return (
    <Box>
      <CssBaseline />
      <Box
        component="main"
        sx={theme => ({
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          gap: 4,
          backgroundColor: theme.palette.grey[900],
          overflow: 'auto',

          ...theme.applyStyles("light", {
            backgroundColor: theme.palette.background.paper
          })
        })}>
        {/* <Container maxWidth={false} sx={{ mt: 0, mb: 0 }}> */}
        <Box
          component="img"
          sx={{
            width: '30vw',
            marginBottom: 2
          }}
          alt="Pinnacle logo"
          src='/logo.svg'
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }}>
          <Typography
            variant="h5"
            sx={{
              display: "block",
              textAlign: "center"
            }}>
            {getLanguage().startsWith('de') ? (
              <>
                Projektmanagement für Führungskräfte<br /> Einfach
                automatisch und auf das Wesentliche reduziert.
              </>
            ) : (
              <>
                Easy, automated and focusing on the essentials.
              </>
            )}
          </Typography>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                handleRedirect();
              }
            }}
            sx={{ marginTop: 5, marginBottom: 1, width: 460 }}
          />
          <Button variant="contained" onClick={handleRedirect} disabled={!email} sx={{ width: 460 }}>
            <Typography variant="button" sx={{
              display: "block"
            }}>
              {getLanguage().startsWith('de') ? "Weiter" : "Continue"}
            </Typography>
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
